'use strict';

import { view } from '@/functions';

const prefix = '/risk-analysis';

export default [
    {
        path: prefix,
        name: 'risk-analysis',
        meta: {
            title: 'Risk Analysis',
            scopes: ['access_tendencys_risk'],
        },
        component: () => view('risk-analysis/index'),
    },
];
